import { cn } from '../../lib/utils'

const fieldBase =
  'w-full cursor-pointer rounded-2xl border border-input bg-background px-4 py-2.5 text-sm text-foreground shadow-sm transition-all duration-150 hover:border-border focus:border-ring focus:outline-none focus:ring-2 focus:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60'

const fieldError = 'border-destructive hover:border-destructive focus:border-destructive focus:ring-destructive/25'

export function Select({ id, label, error = null, className = '', disabled = false, children, ...props }) {
  return (
    <div className={className}>
      {label ? (
        <label
          htmlFor={id}
          className={cn(
            'mb-2 block text-sm font-medium',
            disabled ? 'text-muted-foreground' : 'text-foreground',
          )}
        >
          {label}
        </label>
      ) : null}
      <select id={id} disabled={disabled} className={cn(fieldBase, error && fieldError)} {...props}>
        {children}
      </select>
      {error ? <p className="mt-2 text-xs font-medium text-destructive">{error}</p> : null}
    </div>
  )
}
